import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import api from '@/utils/api';

/**
 * NotificationBadge - Bell icon with badge showing new calls count
 * Fetches count of new calls in user's areas of interest
 */
const NotificationBadge = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchNewCallsCount();
    
    // Refresh count every 5 minutes
    const interval = setInterval(fetchNewCallsCount, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const fetchNewCallsCount = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/notifications/new-calls-count');
      setCount(response.data.count || 0);
    } catch (error) {
      console.error('Error fetching new calls count:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async () => {
    // Mark calls as seen to reset badge
    try {
      await api.post('/api/notifications/mark-calls-seen');
      setCount(0);
    } catch (error) {
      console.error('Error marking calls as seen:', error);
    }
    
    // Navigate to notifications
    navigate('/notifications');
  };

  return (
    <Button
      data-testid="notifications-btn"
      variant="ghost"
      size="icon"
      onClick={handleClick}
      className="relative"
    >
      <Bell className="h-5 w-5" />
      {count > 0 && (
        <span 
          data-testid="notification-badge"
          className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 animate-pulse"
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Button>
  );
};

export default NotificationBadge;
